import { render, staticRenderFns } from "./RecentActivity.vue?vue&type=template&id=19d4dbc2"
import script from "./RecentActivity.ts?vue&type=script&lang=ts&external"
export * from "./RecentActivity.ts?vue&type=script&lang=ts&external"
import style0 from "./RecentActivity.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports